export const DELIVERY_PERMISSIONS_LOAD_REQUEST = 'DELIVERY_PERMISSIONS_LOAD_REQUEST';
export const DELIVERY_PERMISSIONS_LOAD_SUCCESS = 'DELIVERY_PERMISSIONS_LOAD_SUCCESS';
export const DELIVERY_PERMISSIONS_LOAD_FAILURE = 'DELIVERY_PERMISSIONS_LOAD_FAILURE';
